module.exports = __webpack_public_path__ + "img/img-79.30ae0cf8.png";